import React from "react";

const PauseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M7.9875 14.8325V4.1675C7.9875 3.155 7.56 2.75 6.48 2.75H3.7575C2.6775 2.75 2.25 3.155 2.25 4.1675V14.8325C2.25 15.845 2.6775 16.25 3.7575 16.25H6.48C7.56 16.25 7.9875 15.845 7.9875 14.8325Z"
        stroke="#F87E4A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7492 14.8325V4.1675C15.7492 3.155 15.3217 2.75 14.2417 2.75H11.5192C10.4467 2.75 10.0117 3.155 10.0117 4.1675V14.8325C10.0117 15.845 10.4392 16.25 11.5192 16.25H14.2417C15.3217 16.25 15.7492 15.845 15.7492 14.8325Z"
        stroke="#F87E4A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PauseIcon;
